import { render, staticRenderFns } from "./AdminVerwalten.vue?vue&type=template&id=e55536ec&"
import script from "./AdminVerwalten.vue?vue&type=script&lang=js&"
export * from "./AdminVerwalten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports